import { Box, Grid, Typography, styled } from "@mui/material";
import React from "react";
import { Header } from "../styles";
import { theme } from "../styles/theme";

const STATUS_COLOR = {
  0: theme.machineStatus.gray,
  1: theme.machineStatus.green,
  2: theme.machineStatus.yellow,
  3: theme.machineStatus.red,
};

const STATUS_BORDER_COLOR = {
  0: theme.machineBorderStatus.gray,
  1: theme.machineBorderStatus.green,
  2: theme.machineBorderStatus.yellow,
  3: theme.machineBorderStatus.red,
};

const MachineBox = styled(Box)(({ bgcolor, bdcolor }) => ({
  backgroundColor: bgcolor,
  border: `1px solid ${bdcolor}`,
  padding: "15px",
  borderRadius: "18px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const MachineIcon = styled("img")({
  width: "70px",
  height: "40px",
  objectFit: "contain",
});

const Label = styled(Typography)({
  marginTop: "8px",
  color: "#fff",
  fontSize: "20px",
  textAlign: "center",
});

// เส้นเชื่อมแบบเต็ม
const Line = styled(Box)({
  width: "80%",
  height: "5px",
  backgroundColor: "rgba(255,255,255,0.25)",
  margin: "0 auto",
  position: "relative",
  bottom: "16px",
});

export default function StatusMachine({ statusMachine }) {
  return (
    <>
      <Header>STATUS MACHINE</Header>

      <Grid
        container
        alignItems="center"
        justifyContent="center"
        sx={{ mt: 2 }}
      >
        <React.Fragment>
          {/* กล่องเครื่องจักร */}
          <Grid
            item
            lg={0.8}
            md={1}
            xs={2.3}
            sx={{ textAlign: "center" }}
          >
            <MachineBox
              bgcolor={STATUS_COLOR[statusMachine?.STATUS_PREPARATION === undefined ? 0 : statusMachine?.STATUS_PREPARATION]}
              bdcolor={STATUS_BORDER_COLOR[statusMachine?.STATUS_PREPARATION === undefined ? 0 : statusMachine?.STATUS_PREPARATION]}
              >
                <MachineIcon src={statusMachine?.STATUS_PREPARATION_IS_CONNECTED === true ? `${process.env.PUBLIC_URL}/images/icons/Machine_Preparation.png` :  `${process.env.PUBLIC_URL}/images/icons/no-wifi.png`} />
            </MachineBox>
            <Label>Preparation</Label>
          </Grid>

          {/* เส้นเชื่อม */}
          <Grid
            item
            md={0.3}
            xs={0.3}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <Line />
          </Grid>

          {/* กล่องเครื่องจักร */}
          <Grid
            item
            lg={0.8}
            md={1}
            xs={2.3}
            sx={{ textAlign: "center" }}
          >
            <MachineBox
              bgcolor={STATUS_COLOR[statusMachine?.STATUS_COOKING_1 === undefined ? 0 : statusMachine?.STATUS_COOKING_1]}
              bdcolor={STATUS_BORDER_COLOR[statusMachine?.STATUS_COOKING_1 === undefined ? 0 : statusMachine?.STATUS_COOKING_1]}
            >
              <MachineIcon src={statusMachine?.STATUS_COOKING_1_IS_CONNECTED === true ? `${process.env.PUBLIC_URL}/images/icons/Machine_Fryer_1_2.png`: `${process.env.PUBLIC_URL}/images/icons/no-wifi.png`} />
            </MachineBox>
            <Label>Fryer 1</Label>
          </Grid>

          {/* เส้นเชื่อม */}
          <Grid
            item
            md={0.3}
            xs={0.3}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <Line />
          </Grid>

          {/* กล่องเครื่องจักร */}
          <Grid
            item
            lg={0.8}
            md={1}
            xs={2.3}
            sx={{ textAlign: "center" }}
          >
            <MachineBox
              bgcolor={STATUS_COLOR[statusMachine?.STATUS_BELTSCALE_CK === undefined ? 0 : statusMachine?.STATUS_BELTSCALE_CK]}
              bdcolor={STATUS_BORDER_COLOR[statusMachine?.STATUS_BELTSCALE_CK === undefined ? 0 : statusMachine?.STATUS_BELTSCALE_CK]}
            >
              <MachineIcon src={statusMachine?.STATUS_BELTSCALE_CK_IS_CONNECTED === true ? `${process.env.PUBLIC_URL}/images/icons/belt-scale.png` : `${process.env.PUBLIC_URL}/images/icons/no-wifi.png`} />
            </MachineBox>
            <Label>Belt-Scale 1</Label>
          </Grid>
          {/* เส้นเชื่อม */}
          <Grid
            item
            md={0.3}
            xs={0.3}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <Line />
          </Grid>
          {/* กล่องเครื่องจักร */}
          <Grid
            item
            lg={0.8}
            md={1}
            xs={2.3}
            sx={{ textAlign: "center" }}
          >
            <MachineBox
              bgcolor={STATUS_COLOR[statusMachine?.STATUS_COOKING_2 === undefined ? 0 : statusMachine?.STATUS_COOKING_2]}
              bdcolor={STATUS_BORDER_COLOR[statusMachine?.STATUS_COOKING_2 === undefined ? 0 : statusMachine?.STATUS_COOKING_2]}
            >
              <MachineIcon src={statusMachine?.STATUS_COOKING_2_IS_CONNECTED === true ?`${process.env.PUBLIC_URL}/images/icons/Machine_Fryer_1_2.png` : `${process.env.PUBLIC_URL}/images/icons/no-wifi.png`} />
            </MachineBox>
            <Label>Fryer 2</Label>
          </Grid>

          {/* เส้นเชื่อม */}
          <Grid
            item
            md={0.3}
            xs={0.3}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <Line />
          </Grid>

          {/* กล่องเครื่องจักร */}
          <Grid
            item
            lg={0.8}
            md={1}
            xs={2.3}
            sx={{ textAlign: "center" }}
          >
            <MachineBox
              bgcolor={STATUS_COLOR[statusMachine?.STATUS_BELTSCALE_CL === undefined ? 0 : statusMachine?.STATUS_BELTSCALE_CL]}
              bdcolor={STATUS_BORDER_COLOR[statusMachine?.STATUS_BELTSCALE_CL === undefined ? 0 : statusMachine?.STATUS_BELTSCALE_CL]}
            >
              <MachineIcon src={statusMachine?.STATUS_BELTSCALE_CL_IS_CONNECTED === true ?`${process.env.PUBLIC_URL}/images/icons/belt-scale.png` : `${process.env.PUBLIC_URL}/images/icons/no-wifi.png`} />
            </MachineBox>
            <Label>Belt-Scale 2</Label>
          </Grid>

          <Grid
            item
            md={0.3}
            xs={0.3}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <Line />
          </Grid>

          {/* กล่องเครื่องจักร */}
          <Grid
            item
            lg={0.8}
            md={1}
            xs={2.3}
            sx={{ textAlign: "center" }}
          >
            <MachineBox
              bgcolor={STATUS_COLOR[statusMachine?.STATUS_AI_INSPECTION === undefined ? 0 : statusMachine?.STATUS_AI_INSPECTION]}
              bdcolor={STATUS_BORDER_COLOR[statusMachine?.STATUS_VISION === undefined ? 0 : statusMachine?.STATUS_AI_INSPECTION]}
            >
              <MachineIcon src={statusMachine?.STATUS_AI_INSPECTION_IS_CONNECTED === true ? `${process.env.PUBLIC_URL}/images/icons/eye.png` : `${process.env.PUBLIC_URL}/images/icons/no-wifi.png`} />
            </MachineBox>
            <Label>Vision</Label>
          </Grid>

          {/* เส้นเชื่อม */}
          <Grid
            item
            md={0.3}
            xs={0.3}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <Line />
          </Grid>

          {/* กล่องเครื่องจักร */}
          <Grid
            item
            lg={0.8}
            md={1}
            xs={2.3}
            sx={{ textAlign: "center" }}
          >
            <MachineBox
              bgcolor={STATUS_COLOR[statusMachine?.STATUS_FREEZING === undefined ? 0 : statusMachine?.STATUS_FREEZING]}
              bdcolor={STATUS_BORDER_COLOR[statusMachine?.STATUS_FREEZING === undefined ? 0 : statusMachine?.STATUS_FREEZING]}
            >
              <MachineIcon src={statusMachine?.STATUS_FREEZING_IS_CONNECTED === true ? `${process.env.PUBLIC_URL}/images/icons/Machine_Freezing.png` : `${process.env.PUBLIC_URL}/images/icons/no-wifi.png`} />
            </MachineBox>
            <Label>Freezing</Label>
          </Grid>

          {/* เส้นเชื่อม */}
          <Grid
            item
            md={0.3}
            xs={0.3}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <Line />
          </Grid>

          {/* กล่องเครื่องจักร */}
          <Grid
            item
            lg={0.8}
            md={1}
            xs={2.3}
            sx={{ textAlign: "center" }}
          >
            <MachineBox
              bgcolor={STATUS_COLOR[statusMachine?.STATUS_WEIGHING === undefined ? 0 : statusMachine?.STATUS_WEIGHING]}
              bdcolor={STATUS_BORDER_COLOR[statusMachine?.STATUS_WEIGHING === undefined ? 0 : statusMachine?.STATUS_WEIGHING]}
            >
              <MachineIcon src={statusMachine?.STATUS_WEIGHING_IS_CONNECTED === true ? `${process.env.PUBLIC_URL}/images/icons/Machine_Weight.png` : `${process.env.PUBLIC_URL}/images/icons/no-wifi.png`} />
            </MachineBox>
            <Label>Weighing</Label>
          </Grid>

          {/* เส้นเชื่อม */}
          <Grid
            item
            md={0.3}
            xs={0.3}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <Line />
          </Grid>

          {/* กล่องเครื่องจักร */}
          <Grid
            item
            lg={0.8}
            md={1}
            xs={2.3}
            sx={{ textAlign: "center" }}
          >
            <MachineBox
              bgcolor={STATUS_COLOR[statusMachine?.STATUS_PACKING === undefined ? 0 : statusMachine?.STATUS_PACKING]}
              bdcolor={STATUS_BORDER_COLOR[statusMachine?.STATUS_PACKING === undefined ? 0 : statusMachine?.STATUS_PACKING]}
            >
              <MachineIcon src={statusMachine?.STATUS_PACKING_IS_CONNECTED === true ? `${process.env.PUBLIC_URL}/images/icons/Machine_Packing.png` : `${process.env.PUBLIC_URL}/images/icons/no-wifi.png`} />
            </MachineBox>
            <Label>Packing</Label>
          </Grid>

          {/* เส้นเชื่อม */}
          <Grid
            item
            md={0.3}
            xs={0.3}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <Line />
          </Grid>

          {/* กล่องเครื่องจักร */}
          <Grid
            item
            lg={0.8}
            md={1}
            xs={2.3}
            sx={{ textAlign: "center" }}
          >
            <MachineBox
              bgcolor={STATUS_COLOR[statusMachine?.STATUS_INSPECTION === undefined ? 0 : statusMachine?.STATUS_INSPECTION]}
              bdcolor={STATUS_BORDER_COLOR[statusMachine?.STATUS_INSPECTION === undefined ? 0 : statusMachine?.STATUS_INSPECTION]}
            >
              <MachineIcon src={statusMachine?.STATUS_INSPECTION_IS_CONNECTED === true ? `${process.env.PUBLIC_URL}/images/icons/Machine_Inspection.png` : `${process.env.PUBLIC_URL}/images/icons/no-wifi.png`} />
            </MachineBox>
            <Label>Inspection</Label>
          </Grid>

          {/* เส้นเชื่อม */}
          <Grid
            item
            md={0.3}
            xs={0.3}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <Line />
          </Grid>

          {/* กล่องเครื่องจักร */}
          <Grid
            item
            lg={0.8}
            md={1}
            xs={2.3}
            sx={{ textAlign: "center" }}
          >
            <MachineBox
              bgcolor={STATUS_COLOR[statusMachine?.STATUS_CATTONING === undefined ? 0 : statusMachine?.STATUS_CATTONING]}
              bdcolor={STATUS_BORDER_COLOR[statusMachine?.STATUS_CATTONING === undefined ? 0 : statusMachine?.STATUS_CATTONING]}
            >
              <MachineIcon src={statusMachine?.STATUS_CATTONING_IS_CONNECTED === true ? `${process.env.PUBLIC_URL}/images/icons/Machine_Carton.png` : `${process.env.PUBLIC_URL}/images/icons/no-wifi.png`} />
            </MachineBox>
            <Label>Cartoning</Label>
          </Grid>

        </React.Fragment>
      </Grid>
    </>
  );
}
